<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-50"
    >
    
      <div class="mx-2 w-full max-w-4xl max-h-full bg-white shadow-lg rounded-lg px-5 overflow-auto">

        <div class="sticky top-0 z-50 py-5 bg-white flex justify-between">
          <div-title class="text-2xl font-bold" :colorP="colorP">
            Visualización de ficha
          </div-title>
          <div>
            <button aria-label="Cerrar" class="text-xl text-gray-500" @click.prevent="close">
              ×
            </button>
          </div>
        </div>

        <div>
          
          <div
            v-for="(question, index) in questions"
            :key="'question' + question.id_pregunta"
            v-show="isQuestionVisible(index)"
          >
            <template v-if="answers && answers[index]">

              <!-- Divisor de SECCION -->
              <div v-if="question.tipo === 'SECCION'" class="my-6">
                <div class="border-b-2 mx-6 border-gray-400 pb-2">
                  <h2 class="text-xl font-bold text-gray-800 uppercase tracking-wide">
                    {{ question.numero_pregunta }}.- {{ question.texto }}
                  </h2>
                  <p
                    v-if="question.nota_para_registrante"
                    class="text-gray-600 text-sm mt-1"
                  >
                    Nota: {{ question.nota_para_registrante }}
                  </p>
                  <p
                    v-if="question.descripcion"
                    class="text-gray-600 text-sm mt-1"
                  >
                    {{ question.descripcion }}
                  </p>
                </div>
              </div>
              <!-- /Divisor de SECCION -->

              <!-- preguna LABEL, NOTA, DESCRIPCION -->
              <div v-else class="text-xs text-gray-700 px-6 mt-6 mb-0 ">
                <label
                  class="block uppercase font-bold"
                  :for="'question' + index"
                >
                  {{ question.numero_pregunta }}.- {{ question.texto }}
                  <span
                      v-if="question.nota_para_registrante"
                      class="italic font-light normal-case"
                    >
                      ({{ question.nota_para_registrante }})
                  </span>
                </label>
                <p v-if="question.descripcion">
                  {{ question.descripcion }}
                </p>
              </div>
              <!-- /preguna LABEL, NOTA, DESCRIPCION -->
            
              <!-- pregunta tipo ABIERTA -->
              <div v-if="question.tipo === 'ABIERTA'">
                <div class="w-full px-6 mb-6 md:mb-0">
                  <template v-if="question.tipo_dato === 'texto'">
                    <textarea
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      :id="'question' + index"
                      type="text"
                      :name="'question' + index"
                      v-model="answers[index].respuesta.main"
                    />
                  </template>
                  <template v-else>
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      :id="'question' + index"
                      :type="question.tipo_dato === 'numero'? 'number' : question.tipo_dato === 'fecha'? 'date' : question.tipo_dato === 'hora'? 'time' : 'text'"
                      :min="question.tipo_dato === 'numero'? question.rango_min : null"
                      :max="question.tipo_dato === 'numero'? question.rango_max : null"
                      :name="'question' + index"
                      v-model.number="answers[index].respuesta.main"
                    />
                  </template>
                  <p
                    v-if="answers[index].error"
                    class="text-red-500 text-xs italic pb-3"
                  >
                    Ingrese la respuesta.
                  </p>
                  <p
                    v-if="answers[index].error_rango"
                    class="text-red-500 text-xs italic pb-3"
                  >
                    El valor debe estar entre {{ question.rango_min !== null ? question.rango_min : '-∞' }} y {{ question.rango_max !== null ? question.rango_max : '∞' }}.
                  </p>
                </div>

                <!-- subpreguntas-->
                <template>
                  <div
                    class="w-full pl-12 pr-6 mb-6 md:mb-0"
                    v-for="(subpregunta, subSIndex) in question.subpregunta"
                    :key="'subS' + subSIndex"
                  >
                    {{ subpregunta }}
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      :for="'subquestion' + subSIndex"
                      >{{ subpregunta.numero_pregunta }}.-
                      {{ subpregunta.texto }}</label
                    >

                    <template>
                  <div
                    class="w-full pl-12 pr-6 mb-6 md:mb-0"
                    v-for="(subpregunta, subSIndex) in question.subpregunta"
                    :key="'subS' + subSIndex"
                  >
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      :for="'subquestion' + subSIndex"
                      >{{ subpregunta.numero_pregunta }}.-
                      {{ subpregunta.texto }}</label
                    >
                    <!-- Subpregunta tipo selección->abierta -->
                    <template v-if="subpregunta.tipo === 'ABIERTA'">
                      <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        :id="'subquestion' + subSIndex"
                        :type="subpregunta.tipo_dato === 'numero'? 'number' : subpregunta.tipo_dato === 'fecha'? 'date' : subpregunta.tipo_dato === 'hora'? 'time' : 'text'"
                        :name="'subquestion' + subSIndex"
                        v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta"
                      />
                      <p
                        v-if="answers[index].respuesta.subpregunta[subSIndex].error"
                        class="text-red-500 text-xs italic pb-3"
                      >
                        Ingrese la respuesta.
                      </p>
                    </template>
                    <!-- /Subpregunta tipo selección->abierta -->

                    <!-- Subpregunta tipo selección->selección -->
                    <template v-if="subpregunta.tipo === 'SELECCION'">
                      <div class="relative">
                        <select
                          v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta.selected_answer"
                          :name="'subquestion' + subSIndex"
                          class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        >
                          <option disabled selected value="">Seleccione una</option>
                          <option v-for="(option, subOIndex) in subpregunta.opciones" :key="'subO' + subOIndex" :value="option">
                            {{ option }}
                          </option>
                          <option v-if="subpregunta.otro == true" value="Otro">
                            Otro
                          </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                          <svg
                            class="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                          </svg>
                        </div>
                      </div>

                      <div
                        v-if="answers[index].respuesta.subpregunta[subSIndex].respuesta.selected_answer === 'Otro'"
                        class="flex items-center text-gray-700 font-bold mb-3"
                      >
                        <span class="text-sm"> Otro </span>
                        <input
                          type="text"
                          class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                          v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta.otro"
                        />
                      </div>
                      <p
                        v-if="answers[index].respuesta.subpregunta[subSIndex].error"
                        class="text-red-500 text-xs italic pb-3"
                      >
                        Seleccione la respuesta.
                      </p>
                    </template>
                    <!-- /Subpregunta tipo selección->selección -->

                    <!-- Subpregunta tipo selección->campos -->
                    <template v-if="subpregunta.tipo === 'CAMPOS'">

                      <div v-for="(campo, subFieldIndex) in subpregunta.campos" :key="'subf' + subFieldIndex" class="ml-6">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'subquestionField' + subFieldIndex"
                          >{{ campo.texto }}</label
                        >
                        <input
                          class="appearance-none block w-1/2 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          :id="'subquestionField' + subFieldIndex"
                          :type="campo.tipo === 'numero'? 'number' : campo.tipo === 'fecha'? 'date' : campo.tipo === 'hora'? 'time' : 'text'"
                          :name="'subquestionField' + subFieldIndex"
                          v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta[campo.texto]"
                        />
                      </div>
                      <p
                        v-if="answers[index].respuesta.subpregunta[subSIndex].error"
                        class="text-red-500 text-xs italic pb-3"
                      >
                        Ingrese la respuesta.
                      </p>
                    </template>
                    <!-- /Subpregunta tipo selección->campos -->
                  </div>
                </template>
                    
                  </div>
                </template>
              </div>
              <!-- /pregunta tipo ABIERTA -->

              <!-- pregunta tipo FOTO -->
              <div v-if="question.tipo === 'FOTO'">
                <div class="w-full px-6 mb-6 md:mb-0">
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    type="file"
                    accept="image/*"
                    multiple
                  />
                  <div class="text-sm italic text-gray-500 mt-2">
                    Área de vista previa (Hasta {{ question.max_fotos || 4 }} imágenes).
                  </div>
                </div>
              </div>
              <!-- /pregunta tipo FOTO -->

              <!-- pregunta tipo MULTISELECCION -->
              <div v-if="question.tipo === 'MULTISELECCION'">
                <div class="w-full px-6 mb-6 md:mb-0">
                  <label
                    v-for="(option, optIndex) in question.opciones"
                    class="flex items-center text-gray-700 font-bold"
                    :class="
                      optIndex === question.opciones.length - 1 &&
                      !question.otro
                        ? 'mb-3'
                        : ''
                    "
                    :key="'opt' + optIndex"
                  >
                    <input
                      class="mr-2 leading-tight"
                      type="checkbox"
                      v-model="answers[index].respuesta.opciones[option]"
                    />
                    <span class="text-sm">
                      {{ option }}
                    </span>
                  </label>

                  <div
                    v-if="question.otro"
                    class="flex items-center text-gray-700 font-bold mb-3"
                  >
                    <input class="mr-2 leading-tight" type="checkbox" />
                    <span class="text-sm"> Otro </span>
                    <input
                      :type="question.tipo_otro === 'numero'? 'number' : question.tipo_otro === 'fecha'? 'date' : question.tipo_otro === 'hora'? 'time' : 'texto'"
                      class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                      v-model.number="answers[index].respuesta.otro"
                    />
                  </div>

                  <!-- Subpreguntas de la pregunta multiselección -->
                  <template>
                    <div
                      class="w-full pl-6 pr-6 mb-6 md:mb-0"
                      v-for="(subpregunta, subSIndex) in question.subpregunta"
                      :key="'subS' + subSIndex"
                    >
                      <label
                        class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                        :for="'subquestion' + subSIndex"
                        >{{ subpregunta.numero_pregunta }}.-
                        {{ subpregunta.texto }}</label
                      >
                      <!-- Subpregunta tipo multiselección->abierta -->
                      <div v-if="subpregunta.tipo === 'ABIERTA'">
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          :id="'subquestion' + subSIndex"
                          :type="subpregunta.tipo_dato === 'numero'? 'number' : subpregunta.tipo_dato === 'fecha'? 'date' : subpregunta.tipo_dato === 'hora'? 'time' : 'texto'"
                          :name="'subquestion' + subSIndex"
                          v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta"
                        />
                        <p
                          v-if="answers[index].respuesta.subpregunta[subSIndex].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
                      </div>
                      <!-- /Subpregunta tipo multiselección->abierta -->

                      <!-- /Subpregunta tipo multiselección->selección -->
                      <template v-if="subpregunta.tipo === 'SELECCION'">
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta.selected_answer"
                            :name="'subquestion' + subSIndex"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected value="">Seleccione una</option>
                            <option v-for="(option, subOIndex) in subpregunta.opciones" :key="'subO' + subOIndex" :value="option">
                              {{ option }}
                            </option>
                            <option
                              v-if="subpregunta.otro == true"
                              value="Otro"
                            >
                              Otro
                            </option>
                          </select>
                          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                            </svg>
                          </div>
                        </div>

                        <div
                          v-if="answers[index].respuesta.subpregunta[subSIndex].respuesta.selected_answer === 'Otro'"
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <span class="text-sm"> Otro </span>
                          <input
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta.otro"
                          />
                        </div>

                        <p
                          v-if="answers[index].respuesta.subpregunta[subSIndex].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione la respuesta.
                        </p>
                      </template>
                      <!-- /Subpregunta tipo multiselección->selección -->

                      <!-- Subpregunta tipo multiselección->campos -->
                      <div v-if="subpregunta.tipo === 'CAMPOS'" class="ml-6">
                        <template
                          v-for="(campo, subFieldIndex) in subpregunta.campos"
                        >
                          <template>
                            <div :key="'subf' + subFieldIndex">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'subquestionField' + subFieldIndex"
                                >{{ campo.texto }}</label
                              >
                              <input
                                class="appearance-none block w-1/2 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                :id="'subquestionField' + subFieldIndex"
                                :type="campo.tipo === 'numero'? 'number' : campo.tipo === 'fecha'? 'date' : campo.tipo === 'hora'? 'time' : 'text'"
                                :name="'subquestionField' + subFieldIndex"
                                v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta[campo.texto]"
                              />
                            </div>
                          </template>
                        </template>
                        <p
                          v-if="answers[index].respuesta.subpregunta[subSIndex].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
                      </div>
                      <!-- /Subpregunta tipo multiselección->campos -->
                    </div>
                  </template>
                  <!-- /Subpreguntas de la pregunta multiselección -->
                </div>
              </div>
              <!-- /pregunta tipo MULTISELECCION -->

              <!-- pregunta tipo SELECCION_CONDICIONAL -->
              <div v-if="question.tipo === 'SELECCION_CONDICIONAL'">
                <div class="w-full px-6 mb-6 md:mb-0">
                  <div class="relative">
                    <select
                      v-model="answers[index].respuesta.selected_answer"
                      :name="'question' + index"
                      class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    >
                      <option disabled selected value="">Seleccione una</option>
                      <option v-for="(option, scOIndex) in question.opciones" :key="'scO' + scOIndex" :value="option">
                        {{ option }}
                      </option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        class="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        aria-hiden="true"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                      </svg>
                    </div>
                  </div>
                  <p
                    v-if="answers[index].error"
                    class="text-red-500 text-xs italic pb-3"
                  >
                    Seleccione la respuesta.
                  </p>
                </div>

                <!-- pregunta tipo CONDICIONADAS -->
                <template v-for="(value, key, keyIndex) in question.pregunta_condicion">
                  <div 
                    v-if="answers[index].respuesta.selected_answer === key"
                    class="w-full pl-12 pr-6 mb-6 md:mb-0"
                  >
                    <label 
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      :for="'questionCond' + index"
                    >
                      {{ value.numero_pregunta }}.- 
                      {{ value.texto }}
                    </label>
                    <p
                      v-if="value.nota_para_registrante"
                      class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                    >
                      {{ value.nota_para_registrante }}
                    </p>
                    
                    <!-- pregunta condicionada tipo abierta -->
                    <template v-if="value.tipo === 'ABIERTA'">
                      <template  v-if="value.tipo_dato === 'texto'">
                        <textarea
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          :name="'questionCond' + index"
                          :id="'questionCond' + index"
                          v-model="answers[index].respuesta.conditional_answer[key].respuesta"
                        />
                      </template>
                      <template v-else>
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          :type="value.tipo_dato === 'numero' ? 'number' : value.tipo_dato === 'fecha'? 'date' : value.tipo_dato === 'hora'? 'time' : 'text'"
                          :name="'questionCond' + index"
                          :id="'questionCond' + index"
                          v-model="answers[index].respuesta.conditional_answer[key].respuesta"
                        />
                      </template>
                      <p
                        v-if="answers[index].respuesta.conditional_answer[key].error"
                        class="text-red-500 text-xs italic pb-3"
                      >
                        Ingrese la respuesta.
                      </p>
                    </template>
                    <!-- /pregunta condicionada tipo abierta -->

                    <!-- pregunta condicionada tipo selección -->
                    <template v-if="question.pregunta_condicion[key].tipo === 'SELECCION'">
                      <div class="relative">
                        <select
                          v-model="answers[index].respuesta.conditional_answer[key].respuesta"
                          :name="'questionCond' + index"
                          class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        >
                          <option disabled selected value="">Seleccione una</option>
                          <option v-for="(option, condOIndex) in question.pregunta_condicion[key].opciones" :key="'condO' + condOIndex" :value="option">
                            {{ option }}
                          </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                          <svg
                            class="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path
                              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                            />
                          </svg>
                        </div>
                      </div>
                    </template>
                    <!-- /pregunta condicionada tipo selección -->

                    <!-- pregunta condicionada tipo campos -->
                    <template v-if="value.tipo === 'CAMPOS'">
                      <div 
                        v-for="(campo, condFieldIndex) in value.campos" 
                        :key="'condf' + condFieldIndex"
                        class="ml-6"
                      >
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'condField' + condFieldIndex"
                          >{{ campo.texto }}</label
                        >
                        <input
                          class="block w-1/2 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          :id="'condField' + condFieldIndex"
                          :name="'condField' + condFieldIndex"

                          :type="campo.tipo === 'numero' ? 'number' : (campo.tipo === 'fecha' ? 'date' : (campo.tipo === 'hora' ? 'time' : 'text'))"
                          :min="campo.tipo === 'numero' ? campo.rango_min : null"
                          :max="campo.tipo === 'numero' ? campo.rango_max : null"
                          
                          v-model="answers[index].respuesta.conditional_answer[key].respuesta[campo.texto]"
                        />
                      </div>
                    </template>
                    <!-- /pregunta condicionada tipo campos -->
                  </div>

                  <!-- subpreguntas -->
                  <template
                    v-if="answers[index].respuesta.selected_answer === key"
                  >
                    <template
                      v-for="(subpregunta, subQIndex) in question
                        .pregunta_condicion[key].subpregunta"
                    >
                      <div
                        v-if="subpregunta.tipo === 'SELECCION'"
                        :key="'subCondQ' + subQIndex"
                        class="w-full px-3 mb-6 md:mb-0"
                      >
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'subCondQ' + subQIndex"
                          >{{ subpregunta.numero_pregunta }}.-
                          {{ subpregunta.texto }}</label
                        >
                        <p
                          v-if="subpregunta.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ subpregunta.nota_para_registrante }}
                        </p>
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.conditional_answer[key].subpregunta[subQIndex].respuesta"
                            :name="'subCondQ' + subQIndex"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected value="">Seleccione una</option>
                            <option
                              v-for="(option, subCondOptIndex) in subpregunta.opciones"
                              :key="'subCondOpt' + subCondOptIndex"
                              :value="option"
                            >
                              {{ option }}
                            </option>
                          </select>
                          <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                          >
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </template>
                <!-- /pregunta tipo CONDICIONADAS -->
              </div>
              <!-- /pregunta tipo SELECCION_CONDICIONAL -->

              <!-- pregunta tipo SELECCION -->
              <div v-if="question.tipo === 'SELECCION'">
                <div class="w-full px-6 mb-6 md:mb-0">
                  <div class="relative">
                    <select
                      v-model="answers[index].respuesta.selected_answer"
                      :name="'question' + index"
                      class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    >
                      <option disabled selected value="">Seleccione una</option>
                      <option v-for="(option, sOIndex) in question.opciones" :key="'sO' + sOIndex" :value="option">
                        {{ option }}
                      </option>
                      <option v-if="question.otro == true" value="Otro">
                        Otro
                      </option>
                    </select>
                    <div
                      class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                    >
                      <svg
                        class="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    v-if="answers[index].respuesta.selected_answer === 'Otro'"
                    class="flex items-center text-gray-700 font-bold mb-3"
                  >
                    <span class="text-sm"> Otro </span>
                    <input
                      type="text"
                      class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                      v-model="answers[index].respuesta.otro"
                    />
                  </div>
                  <p
                    v-if="answers[index].error"
                    class="text-red-500 text-xs italic pb-3"
                  >
                    Seleccione la respuesta.
                  </p>
                </div>

                <!-- subpreguntas de la pregunta de selección -->
                <template>
                  <div
                    class="w-full pl-12 pr-6 mb-6 md:mb-0"
                    v-for="(subpregunta, subSIndex) in question.subpregunta"
                    :key="'subS' + subSIndex"
                  >
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      :for="'subquestion' + subSIndex"
                      >{{ subpregunta.numero_pregunta }}.-
                      {{ subpregunta.texto }}</label
                    >
                    <!-- Subpregunta tipo selección->abierta -->
                    <template v-if="subpregunta.tipo === 'ABIERTA'">
                      <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        :id="'subquestion' + subSIndex"
                        :type="subpregunta.tipo_dato === 'numero'? 'number' : subpregunta.tipo_dato === 'fecha'? 'date' : subpregunta.tipo_dato === 'hora'? 'time' : 'text'"
                        :name="'subquestion' + subSIndex"
                        v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta"
                      />
                      <p
                        v-if="answers[index].respuesta.subpregunta[subSIndex].error"
                        class="text-red-500 text-xs italic pb-3"
                      >
                        Ingrese la respuesta.
                      </p>
                    </template>
                    <!-- /Subpregunta tipo selección->abierta -->

                    <!-- Subpregunta tipo selección->selección -->
                    <template v-if="subpregunta.tipo === 'SELECCION'">
                      <div class="relative">
                        <select
                          v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta.selected_answer"
                          :name="'subquestion' + subSIndex"
                          class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        >
                          <option disabled selected value="">Seleccione una</option>
                          <option v-for="(option, subOIndex) in subpregunta.opciones" :key="'subO' + subOIndex" :value="option">
                            {{ option }}
                          </option>
                          <option v-if="subpregunta.otro == true" value="Otro">
                            Otro
                          </option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                          <svg
                            class="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                          </svg>
                        </div>
                      </div>

                      <div
                        v-if="answers[index].respuesta.subpregunta[subSIndex].respuesta.selected_answer === 'Otro'"
                        class="flex items-center text-gray-700 font-bold mb-3"
                      >
                        <span class="text-sm"> Otro </span>
                        <input
                          type="text"
                          class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                          v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta.otro"
                        />
                      </div>
                      <p
                        v-if="answers[index].respuesta.subpregunta[subSIndex].error"
                        class="text-red-500 text-xs italic pb-3"
                      >
                        Seleccione la respuesta.
                      </p>
                    </template>
                    <!-- /Subpregunta tipo selección->selección -->

                    <!-- Subpregunta tipo selección->campos -->
                    <template v-if="subpregunta.tipo === 'CAMPOS'">

                      <div v-for="(campo, subFieldIndex) in subpregunta.campos" :key="'subf' + subFieldIndex" class="ml-6">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'subquestionField' + subFieldIndex"
                          >{{ campo.texto }}</label
                        >
                        <input
                          class="appearance-none block w-1/2 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          :id="'subquestionField' + subFieldIndex"
                          :type="campo.tipo === 'numero'? 'number' : campo.tipo === 'fecha'? 'date' : campo.tipo === 'hora'? 'time' : 'text'"
                          :name="'subquestionField' + subFieldIndex"
                          v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta[campo.texto]"
                        />
                      </div>
                      <p
                        v-if="answers[index].respuesta.subpregunta[subSIndex].error"
                        class="text-red-500 text-xs italic pb-3"
                      >
                        Ingrese la respuesta.
                      </p>
                    </template>
                    <!-- /Subpregunta tipo selección->campos -->
                  </div>
                </template>
                <!-- /subpreguntas de la pregunta de selección -->
              </div>
              <!-- /pregunta tipo SELECCION -->

              <!-- pregunta tipo CAMPOS -->
              <div v-if="question.tipo === 'CAMPOS'">
                <div class="w-full px-6 mb-6 md:mb-0">
                  <template>
                      <div v-for="(campo, fieldIndex) in question.campos" :key="'f' + fieldIndex" class="mb-3">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'questionField' + fieldIndex"
                          >{{ campo.texto }}</label
                        >
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          :id="'questionField' + fieldIndex"
                          :type="campo.tipo === 'numero' ? 'number' : (campo.tipo === 'fecha' ? 'date' : (campo.tipo === 'hora' ? 'time' : 'text'))"
                          :min="campo.tipo === 'numero' ? campo.rango_min : null"
                          :max="campo.tipo === 'numero' ? campo.rango_max : null"
                          :name="'questionField' + fieldIndex"
                          v-model="answers[index].respuesta[campo.texto]"
                        />
                      </div>
                  </template>
                  <p
                    v-if="answers[index].error"
                    class="text-red-500 text-xs italic pb-3"
                  >
                    Ingrese la respuesta.
                  </p>
                </div>
              </div>
              <!-- /pregunta tipo CAMPOS -->

              <!-- pregunta tipo MINI_FORMULARIO -->
              <div v-if="question.tipo === 'MINI_FORMULARIO'">
                <div class="w-full px-6 mb-6 md:mb-0">
                  <template>
                      <div v-for="(campo, fieldIndex) in question.campos" :key="'mf' + fieldIndex" class="mb-3">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'mfField' + fieldIndex"
                          >{{ campo.texto }}</label
                        >
                        <!-- Inputs depending on tipo -->
                        <template v-if="['texto', 'numero', 'fecha', 'hora'].includes(campo.tipo)">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            :id="'mfField' + fieldIndex"
                            :type="campo.tipo === 'numero' ? 'number' : (campo.tipo === 'fecha' ? 'date' : (campo.tipo === 'hora' ? 'time' : 'text'))"
                            :min="campo.tipo === 'numero' ? campo.rango_min : null"
                            :max="campo.tipo === 'numero' ? campo.rango_max : null"
                            :name="'mfField' + fieldIndex"
                            v-model="answers[index].respuesta[campo.texto]"
                          />
                        </template>
                        <template v-else-if="campo.tipo === 'radio'">
                          <div class="flex flex-col gap-2 mb-3">
                            <label v-for="(opt, oi) in campo.opciones" :key="'mfr' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                              <input type="radio"
                                :name="'mfField' + index + '_' + fieldIndex"
                                :value="opt"
                                v-model="answers[index].respuesta[campo.texto]"
                                class="accent-purple-500"
                              />
                              {{ opt }}
                            </label>
                          </div>
                        </template>
                        <template v-else-if="campo.tipo === 'checkbox'">
                          <div class="flex flex-col gap-2 mb-3">
                            <label v-for="(opt, oi) in campo.opciones" :key="'mfc' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                              <input type="checkbox"
                                :name="'mfField' + index + '_' + fieldIndex + '_' + oi"
                                :value="opt"
                                v-model="answers[index].respuesta[campo.texto]"
                                class="accent-purple-500"
                              />
                              {{ opt }}
                            </label>
                          </div>
                        </template>
                        <template v-else-if="campo.tipo === 'select'">
                          <div class="relative">
                            <select
                              v-model="answers[index].respuesta[campo.texto]"
                              :name="'mfField' + index + '_' + fieldIndex"
                              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            >
                              <option disabled selected value="">Seleccione una</option>
                              <option v-for="(option, oIndex) in campo.opciones" :key="'mfs' + oIndex" :value="option">
                                {{ option }}
                              </option>
                            </select>
                            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                              </svg>
                            </div>
                          </div>
                        </template>
                      </div>
                  </template>
                  <p
                    v-if="answers[index].error"
                    class="text-red-500 text-xs italic pb-3"
                  >
                    Ingrese las respuestas obligatorias.
                  </p>
                </div>
              </div>
              <!-- /pregunta tipo MINI_FORMULARIO -->

              <!-- pregunta tipo GRUPO_REPETIBLE -->
              <div v-if="question.tipo === 'GRUPO_REPETIBLE'">
                <div class="w-full px-6 mb-6 md:mb-0">
                  <div v-for="(group, gIndex) in answers[index].respuesta" :key="'group_' + gIndex" class="mb-4 p-4 border border-gray-300 rounded relative bg-gray-50">
                    <button v-if="answers[index].respuesta.length > 1" @click="answers[index].respuesta.splice(gIndex, 1)" type="button" class="absolute top-0 right-0 p-2 text-red-500 hover:text-red-700">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" /></svg>
                    </button>
                    <div class="font-bold text-gray-600 mb-2 text-sm">Registro {{ gIndex + 1 }}</div>
                    
                    <template>
                      <div v-for="(campo, fieldIndex) in question.campos" :key="'rgf_' + gIndex + '_' + fieldIndex" class="mb-3">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1 text-left">
                          {{ campo.texto }} 
                        </label>
                        <template v-if="['texto', 'numero', 'fecha', 'hora'].includes(campo.tipo)">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white"
                            :type="campo.tipo === 'numero' ? 'number' : (campo.tipo === 'fecha' ? 'date' : (campo.tipo === 'hora' ? 'time' : 'text'))"
                            :min="campo.tipo === 'numero' ? campo.rango_min : null"
                            :max="campo.tipo === 'numero' ? campo.rango_max : null"
                            v-model="answers[index].respuesta[gIndex][campo.texto]"
                          />
                        </template>
                        <template v-else-if="campo.tipo === 'radio'">
                          <div class="flex flex-col gap-2 mb-2 mt-1">
                            <label v-for="(opt, oi) in campo.opciones" :key="'rgr_' + gIndex + '_' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                              <input type="radio"
                                :name="'rgField_' + index + '_' + gIndex + '_' + fieldIndex"
                                :value="opt"
                                v-model="answers[index].respuesta[gIndex][campo.texto]"
                                class="accent-teal-500"
                              />
                              {{ opt }}
                            </label>
                            <div v-if="answers[index].respuesta[gIndex][campo.texto] === '99.1. Otro (especifique)'" class="ml-4">
                              <span class="text-sm text-gray-700"> Otro (especifique) </span>
                              <input
                                type="text"
                                class="text-sm text-gray-700 bg-gray-100 border rounded py-1 px-2 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="answers[index].respuesta[gIndex][fieldIndex]"
                              />
                            </div>
                          </div>
                        </template>

                        <template v-else-if="campo.tipo === 'checkbox'">
                          <div class="flex flex-col gap-2 mb-2 mt-1">
                            <label v-for="(opt, oi) in campo.opciones" :key="'rgc_' + gIndex + '_' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                              <input type="checkbox"
                                :name="'rgField_' + index + '_' + gIndex + '_' + fieldIndex + '_' + oi"
                                :value="opt"
                                v-model="answers[index].respuesta[gIndex][campo.texto]"
                                class="accent-teal-500"
                              />
                              {{ opt }}
                            </label>
                            <div v-if="answers[index].respuesta[gIndex][campo.texto].includes('99.1. Otro (especifique)')" class="ml-4">
                              <span class="text-sm text-gray-700"> Otro (especifique) </span>
                              <input
                                type="text"
                                class="text-sm text-gray-700 bg-gray-100 border rounded py-1 px-2 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="answers[index].respuesta[gIndex][fieldIndex]"
                              />
                            </div>
                          </div>
                        </template>

                        <template v-else-if="campo.tipo === 'select'">
                          <div class="relative mt-1 mb-2">
                            <select
                              v-model="answers[index].respuesta[gIndex][campo.texto]"
                              :name="'rgField_' + index + '_' + gIndex + '_' + fieldIndex"
                              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            >
                              <option disabled selected value="">Seleccione una</option>
                              <option v-for="(option, oIndex) in campo.opciones" :key="'rgs_' + oIndex" :value="option">
                                {{ option }}
                              </option>
                            </select>
                            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                              </svg>
                            </div>
                          </div>
                          <div v-if="answers[index].respuesta[gIndex][campo.texto] === '99.1. Otro (especifique)'">
                            <span class="text-sm text-gray-700"> Otro (especifique) </span>
                            <input
                              type="text"
                              class="text-sm text-gray-700 bg-gray-100 border rounded py-1 px-2 ml-2 leading-tight focus:outline-none focus:bg-white"
                              v-model="answers[index].respuesta[gIndex][fieldIndex]"
                            />
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                  
                  <button type="button" @click="addRepeatableGroup(index)" class="flex items-center text-sm text-teal-600 hover:text-teal-800 font-bold mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                    </svg>
                    Agregar otro registro
                  </button>

                  <p
                    v-if="answers[index].error"
                    class="text-red-500 text-xs italic pb-3"
                  >
                    Complete los campos obligatorios.
                  </p>
                </div>
              </div>
              <!-- /pregunta tipo GRUPO_REPETIBLE -->

              <!-- pregunta tipo OPCION_SEGUIMIENTO -->
              <div v-if="question.tipo === 'OPCION_SEGUIMIENTO'">
                <div class="w-full px-6 mb-6 md:mb-0">
                  <!-- Lista de Conceptos -->
                  <div v-for="(concepto, cIdx) in question.conceptos" :key="'concepto_' + cIdx" class="mb-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2 text-left">{{ concepto }}</label>
                    <div class="flex gap-4 mb-2">
                      <label class="flex items-center gap-2 cursor-pointer font-bold text-sm text-gray-700">
                        <input type="radio"
                          :name="'followup_' + index + '_' + cIdx"
                          :value="question.opcion_si"
                          v-model="answers[index].respuesta[cIdx].selected_answer"
                          class="accent-green-500"
                        />
                        {{ question.opcion_si }}
                      </label>
                      <label class="flex items-center gap-2 cursor-pointer font-bold text-sm text-gray-700">
                        <input type="radio"
                          :name="'followup_' + index + '_' + cIdx"
                          :value="question.opcion_no"
                          v-model="answers[index].respuesta[cIdx].selected_answer"
                          class="accent-red-400"
                        />
                        {{ question.opcion_no }}
                      </label>
                    </div>

                    <!-- Sub-formulario (solo cuando selecciona opción SI) -->
                    <transition name="fade">

                      <div v-if="answers[index].respuesta[cIdx].selected_answer === question.opcion_si"
                        class="mt-2 p-3 bg-green-50 border border-green-200 rounded-lg"
                      >
                        <div
                          v-if="concepto ==='99.1. Otro (especifique)'"
                          class="flex items-center text-gray-700 mb-3"
                        >
                          <span class="text-sm"> Otro (especifique) </span>
                          <input
                            :type="question.tipo_otro === 'numero'? 'number' : question.tipo_otro === 'fecha'? 'date' : question.tipo_otro === 'hora'? 'time' : 'texto'"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model.number="answers[index].respuesta.otro"
                          />
                        </div>

                        <!-- Sub-tipo: radio -->
                        <div v-if="question.sub_tipo === 'radio'">
                          <label v-if="question.sub_label" class="block text-xs font-bold text-gray-600 mb-1 uppercase tracking-wide">{{ question.sub_label }}</label>
                          <div :class="question.sub_disposicion === 'horizontal' ? 'flex flex-wrap gap-4' : 'flex flex-col gap-2'">
                            <label
                              v-for="(opt, oi) in question.sub_opciones"
                              :key="'sr_' + index + '_' + cIdx + '_' + oi"
                              class="flex items-center gap-2 cursor-pointer text-sm text-gray-700"
                            >
                              <input type="radio"
                                :name="'sub_radio_' + index + '_' + cIdx"
                                :value="opt"
                                v-model="answers[index].respuesta[cIdx].sub_respuesta"
                                class="accent-green-500"
                              />
                              {{ opt }}
                            </label>
                          </div>
                        </div>
                        <!-- Sub-tipo: checkbox -->
                        <div v-if="question.sub_tipo === 'checkbox'">
                          <label v-if="question.sub_label" class="block text-xs font-bold text-gray-600 mb-1 uppercase tracking-wide">{{ question.sub_label }}</label>
                          <div :class="question.sub_disposicion === 'horizontal' ? 'flex flex-wrap gap-4' : 'flex flex-col gap-2'">
                            <label
                              v-for="(opt, oi) in question.sub_opciones"
                              :key="'sc_' + index + '_' + cIdx + '_' + oi"
                              class="flex items-center gap-2 cursor-pointer text-sm text-gray-700"
                            >
                              <input type="checkbox"
                                :value="opt"
                                v-model="answers[index].respuesta[cIdx].sub_respuesta"
                                class="accent-green-500"
                              />
                              {{ opt }}
                            </label>
                          </div>
                        </div>
                        <!-- Sub-tipo: input -->
                        <div v-if="question.sub_tipo === 'input'">
                          <label v-if="question.sub_label" class="block text-xs font-bold text-gray-600 mb-1 uppercase tracking-wide">{{ question.sub_label }}</label>
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white"
                            :type="question.sub_input_tipo === 'numero' ? 'number' : (question.sub_input_tipo === 'fecha' ? 'date' : (question.sub_input_tipo === 'hora' ? 'time' : 'text'))"
                            :min="question.sub_input_tipo === 'numero' && question.sub_rango_min !== null ? question.sub_rango_min : undefined"
                            :max="question.sub_input_tipo === 'numero' && question.sub_rango_max !== null ? question.sub_rango_max : undefined"
                            v-model="answers[index].respuesta[cIdx].sub_respuesta"
                          />
                        </div>
                      </div>
                    </transition>
                  </div>
                  
                  <p v-if="answers[index].error" class="text-red-500 text-xs italic pb-3">Ingrese la respuesta.</p>
                </div>
              </div>
              <!-- /pregunta tipo OPCION_SEGUIMIENTO -->

              <!-- pregunta tipo FECHA -->
              <div v-if="question.tipo === 'FECHA'">
                <div class="w-full px-6 mb-6 md:mb-0">
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    :id="'question' + index"
                    type="date"
                    :name="'question' + index"
                    v-model="answers[index].respuesta"
                  />
                  <p
                    v-if="answers[index].error"
                    class="text-red-500 text-xs italic pb-3"
                  >
                    Ingrese la respuesta.
                  </p>
                </div>
              </div>
              <!-- /pregunta tipo FECHA -->

              <!-- pregunta tipo MATRIZ -->
              <div v-if="question.tipo === 'MATRIZ'">
                <div class="w-full px-6 mb-6 md:mb-0">
                  <div class="overflow-x-auto mb-3">
                    <table class="w-full text-left border-collapse">
                      <thead>
                        <tr>
                          <th class="border-b-2 p-2"></th>
                          <th
                            v-for="(col, colIdx) in question.columnas"
                            :key="'col' + colIdx"
                            class="border-b-2 p-2 text-sm text-gray-700 font-bold text-center"
                          >
                            {{ col }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(fila, filaIdx) in question.filas"
                          :key="'fila' + filaIdx"
                        >
                          <td class="border-b p-2 text-sm text-gray-700 font-bold">
                            {{ fila }}
                          </td>
                          <td
                            v-for="(col, colIdx) in question.columnas"
                            :key="'cell' + colIdx"
                            class="border-b p-2 text-center"
                          >
                            <input
                              type="radio"
                              :name="'matrix_' + index + '_' + filaIdx"
                              :value="col"
                              v-model="answers[index].respuesta[fila]"
                              class="leading-tight"
                            />
                          </td>
                        </tr>
                        <tr v-if="question.otro">
                          <td class="border-b p-2 text-sm text-gray-700 font-bold">
                            <input
                              v-if="!question.tipo_otro || question.tipo_otro === 'texto'"
                              type="text"
                              placeholder="Otro (opcional)..."
                              class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                              v-model="answers[index].respuesta_otro_fila"
                            />
                            <input
                              v-else-if="question.tipo_otro === 'numero'"
                              type="number"
                              placeholder="Otro (opcional)..."
                              class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                              v-model.number="answers[index].respuesta_otro_fila"
                            />
                            <input
                              v-else-if="question.tipo_otro === 'fecha'"
                              type="date"
                              placeholder="Otro (opcional)..."
                              class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                              v-model="answers[index].respuesta_otro_fila"
                            />
                            <input
                              v-else-if="question.tipo_otro === 'hora'"
                              type="time"
                              placeholder="Otro (opcional)..."
                              class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                              v-model="answers[index].respuesta_otro_fila"
                            />
                          </td>
                          <td
                            v-for="(col, colIdx) in question.columnas"
                            :key="'cell_otro_' + colIdx"
                            class="border-b p-2 text-center"
                          >
                            <input
                              type="radio"
                              :name="'matrix_' + index + '_otro'"
                              :value="col"
                              v-model="answers[index].respuesta_otro_valor"
                              class="leading-tight"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p
                    v-if="answers[index].error"
                    class="text-red-500 text-xs italic pb-3"
                  >
                    Seleccione una opción para todas las filas.
                  </p>
                </div>
              </div>
              <!-- /pregunta tipo MATRIZ -->

            </template>
          </div>
        </div>

        <div class="flex sticky bottom-0 justify-end py-5 bg-white">
          <btn-action
            class="px-4 py-2 text-center rounded-lg text-white tracking-wide"
            @click="close()"
            :colorT="colorT"
          >
            Cerrar
          </btn-action>
        </div>
        
      </div>
    </div>
  </Transition>
</template>

<script>
import EventBus from "../event-bus";
import { styled } from "@egoist/vue-emotion";

const DivTitle = styled("div")`
  color: ${props => props.colorP};
`;

const BtnAction = styled("button")`
  background-color: ${props => props.colorT};
`;

export default {
  name: "project-preview-question-builder",
  data() {
    return {
      questions: [],
      answers: [],
      question_register_radio: "No",
      question_share_ubication_radio: "No",
      question_site_ubication_radio: "No"
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    colorP: {
      required: true
    },
    colorS: {
      required: true
    },
    colorT: {
      required: true
    }
  },
  components: { DivTitle, BtnAction },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  mounted() {
    EventBus.$on("previewQuestions", this.setData);
  },
  methods: {
    setData: function (data) {
      let list = Object.assign({}, data);
      this.questions = list.questions;
      // console.log(list)
      // TODO: revisar para que se necesita borrar todo?
      // this.clearPreviewQuestionsData();
      this.formatQuestions();
    },
    closeProjectPreview() {
      this.questions = [];
    },
    close() {
      this.question_register_radio = "No";
      this.question_share_ubication_radio = "No";
      this.question_site_ubication_radio = "No";

      this.$emit("close");
    },
    clearPreviewQuestionsData() {
      this.questions.forEach(question => {
        switch (question.tipo) {
          case "ABIERTA":
            delete question.error;
            delete question.error_rango;

            if (question.subpregunta) {
              question.subpregunta.forEach(subpregunta => {
                switch (subpregunta.tipo) {
                  case "ABIERTA":
                    delete subpregunta.error;
                    delete subpregunta.error_rango;
                    break;
                  case "SELECCION":
                    delete subpregunta.error;
                    delete subpregunta.optionError;
                    delete subpregunta.minimumError;
                    delete subpregunta.maximumOptionError;
                    break;
                  case "CAMPOS":
                    delete subpregunta.error;
                    delete subpregunta.fieldError;
                    delete subpregunta.minimumError;
                    break;
                  default:
                    break;
                }
              });
            }
            break;
          case "SELECCION":
            delete question.error;
            delete question.optionError;
            delete question.minimumError;
            delete question.maximumOptionError;
            delete question.maximumSubquestionError;
            break;
          case "CAMPOS":
            delete question.error;
            delete question.fieldError;
            delete question.minimumError;
            break;
          case "GRUPO_REPETIBLE":
            delete question.error;
            break;
          case "OPCION_SEGUIMIENTO":
            delete question.error;
            delete question.subTipoError;
            delete question.subOptionError;
            delete question.subMinError;
            break;
          case "MATRIZ":
            delete question.error;
            delete question.filaError;
            delete question.columnaError;
            break;
          case "SECCION":
            delete question.error;
            break;
          case "SELECCION_CONDICIONAL": {
            delete question.error;
            delete question.errorCond;
            delete question.optionError;
            delete question.minimumError;
            delete question.maximumError;
            delete question.duplicateError;
            delete question.maximumOptionError;

            let pregunta_condicion = {};

            if (question.preguntas_condicion) {
              question.preguntas_condicion.forEach(condQuestion => {
                switch (condQuestion.tipo) {
                  case "ABIERTA": {
                    delete condQuestion.error;
                    let key = condQuestion.assignment;

                    delete condQuestion.assignment;
                    delete condQuestion.assignmentError;

                    pregunta_condicion[key] = condQuestion;
                    break;
                  }
                  case "SELECCION": {
                    delete condQuestion.error;
                    delete condQuestion.optionError;
                    delete condQuestion.minimumError;
                    delete condQuestion.maximumOptionError;

                    let key = condQuestion.assignment;

                    delete condQuestion.assignment;
                    delete condQuestion.assignmentError;

                    pregunta_condicion[key] = condQuestion;
                    break;
                  }
                  case "CAMPOS": {
                    delete condQuestion.error;
                    delete condQuestion.fieldError;
                    delete condQuestion.minimumError;

                    let key = condQuestion.assignment;

                    delete condQuestion.assignment;
                    delete condQuestion.assignmentError;

                    pregunta_condicion[key] = condQuestion;
                    break;
                  }
                  default:
                    break;
                }
              });
            }

            delete question.preguntas_condicion;

            question.pregunta_condicion = pregunta_condicion;
            break;
          }
          default:
            break;
        }
      });
    },
    formatQuestions() {
      this.answers = [];
      this.questions.forEach(question => {
        let answer;

        switch (question.tipo) {
          case "ABIERTA":
            answer = {
              main: ""
            };
            if (question["subpregunta"].length > 0) {
              answer["subpregunta"] = [];
              question["subpregunta"].forEach(question => {
                let subAnswer = {
                  respuesta: null
                };
                subAnswer.id_pregunta = question.id_pregunta;
                subAnswer.texto = question.texto;
                subAnswer.tipo = question.tipo;
                if (question.tipo === "ABIERTA") {
                  subAnswer.sensible = false;
                  subAnswer.respuesta = "";
                }
                if (question.tipo === "SELECCION") {
                  subAnswer.respuesta = {
                    selected_answer: "",
                    otro: ""
                  };
                }
                if (question.tipo === "CAMPOS") {
                  subAnswer.sensible = false;
                  subAnswer.respuesta = {};
                  if (question.campos) {
                    question.campos.forEach(campo => {
                      subAnswer.respuesta[campo.texto] = "";
                    });
                  }
                }
                subAnswer.error = false;
                answer["subpregunta"].push(subAnswer);
              });
            }
            break;
          case "MULTISELECCION":
            answer = {
              opciones: {}
            };

            if (question.opciones) {
              question.opciones.forEach(option => {
                answer.opciones[option] = false;
              });
            }

            if (question.otro) {
              answer["otro"] = "";
            }
            if (question["subpregunta"] && question["subpregunta"].length > 0) {
              if (question["subpregunta"].length > 0) {
                answer["subpregunta"] = [];
                question["subpregunta"].forEach(question => {
                  let subAnswer = {
                    respuesta: null
                  };
                  subAnswer.id_pregunta = question.id_pregunta;
                  subAnswer.texto = question.texto;
                  subAnswer.tipo = question.tipo;
                  if (question.tipo === "ABIERTA") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = "";
                  }
                  if (question.tipo === "SELECCION") {
                    subAnswer.respuesta = {
                      selected_answer: "",
                      otro: ""
                    };
                  }
                  if (question.tipo === "CAMPOS") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = {};
                    if (question.campos) {
                      question.campos.forEach(campo => {
                        subAnswer.respuesta[campo.texto] = "";
                      });
                    }
                  }
                  subAnswer.error = false;
                  answer["subpregunta"].push(subAnswer);
                });
              }
            }

            break;
          case "MULTISELECCION_CATEGORIAS":
            answer = {};
            if (question["otro"] == true) {
              answer["otro"] = "";
            }
            answer["categorias"] = {};
            if (question.categorias) {
              question.categorias.forEach(categoria => {
                answer["categorias"][categoria.categoria_nombre] = {};
                if (categoria.opciones) {
                  categoria.opciones.forEach(opcion => {
                    answer["categorias"][categoria.categoria_nombre][
                      opcion
                    ] = false;
                  });
                }
              });
            }
            break;
          case "SELECCION_CONDICIONAL":
            answer = {};
            answer["selected_answer"] = "";
            answer["conditional_answer"] = {};

            Object.entries(question.pregunta_condicion).forEach(
              ([key, value]) => {
                answer["conditional_answer"][key] = {};
                answer["conditional_answer"][key]["id"] = value["id"];
                answer["conditional_answer"][key]["tipo"] = value["tipo"];
                answer["conditional_answer"][key]["texto"] = value["texto"];

                if (value["tipo"] == "ABIERTA") {
                  answer["conditional_answer"][key]["sensible"] = false;
                  answer["conditional_answer"][key]["respuesta"] = "";
                }
                if (value["tipo"] == "MULTISELECCION") {
                  answer["conditional_answer"][key]["respuesta"] = {};

                  answer["conditional_answer"][key]["respuesta"]["opciones"] =
                    {};
                  value["opciones"].forEach(opcion => {
                    answer["conditional_answer"][key]["respuesta"]["opciones"][
                      opcion
                    ] = false;
                  });

                  if (value["otro"] == true) {
                    answer["conditional_answer"][key]["respuesta"]["otro"] = "";
                  }
                }
                if (value["tipo"] == "MULTISELECCION_CATEGORIAS") {
                  answer["conditional_answer"][key]["respuesta"] = {};
                  answer["conditional_answer"][key]["respuesta"]["categorias"] =
                    {};
                  value["categorias"].forEach(categoria => {
                    answer["conditional_answer"][key]["respuesta"][
                      "categorias"
                    ][categoria.categoria_nombre] = {};
                    categoria.opciones.forEach(opcion => {
                      answer["conditional_answer"][key]["respuesta"][
                        "categorias"
                      ][categoria.categoria_nombre][opcion] = false;
                    });
                  });
                  if (value["otro"] == true) {
                    answer["conditional_answer"][key]["respuesta"]["otro"] = "";
                  }
                }

                if (value["tipo"] == "SELECCION") {
                  answer["conditional_answer"][key]["respuesta"] = "";
                }

                if (value["tipo"] === "CAMPOS") {
                  answer["conditional_answer"][key]["sensible"] = false;
                  answer["conditional_answer"][key]["respuesta"] = {};
                  if (question.pregunta_condicion[key].campos) {
                    question.pregunta_condicion[key].campos.forEach(field => {
                      answer["conditional_answer"][key]["respuesta"][
                        field.texto
                      ] = "";
                    });
                  }
                }

                if (question.pregunta_condicion[key].subpregunta) {
                  let subAnswers = [];
                  question.pregunta_condicion[key].subpregunta.forEach(
                    subpregunta => {
                      let subAnswer = {
                        id_pregunta: subpregunta.id_pregunta,
                        texto: subpregunta.texto,
                        tipo: subpregunta.tipo,
                        respuesta: "",
                        sensible: false,
                      };

                      subAnswers.push(subAnswer);
                    }
                  );

                  answer["conditional_answer"][key].subpregunta = subAnswers;
                }

                answer["conditional_answer"][key]["error"] = false;
              }
            );
            break;
          case "SELECCION":
            answer = {};
            answer["selected_answer"] = "";
            if (question.otro) {
              answer["otro"] = "";
            }
            if (question["subpregunta"] && question["subpregunta"].length > 0) {
              if (question["subpregunta"].length > 0) {
                answer["subpregunta"] = [];
                question["subpregunta"].forEach(question => {
                  let subAnswer = {
                    respuesta: null
                  };
                  subAnswer.id_pregunta = question.id_pregunta;
                  subAnswer.texto = question.texto;
                  subAnswer.tipo = question.tipo;
                  if (question.tipo === "ABIERTA") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = "";
                  }

                  if (question.tipo === "SELECCION") {
                    subAnswer.respuesta = {
                      selected_answer: ""
                    };
                  }

                  if (question.tipo === "CAMPOS") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = {};

                    if (question.campos) {
                      question.campos.forEach(campo => {
                        subAnswer.respuesta[campo.texto] = "";
                      });
                    }
                  }

                  subAnswer.error = false;

                  answer["subpregunta"].push(subAnswer);
                });
              }
            }
            break;
          case "CAMPOS":
            answer = {};
            if (question.campos) {
              question.campos.forEach(field => {
                answer[field.texto] = "";
              });
            }
            break;
          case "MINI_FORMULARIO":
            answer = {};
            if (question.campos) {
              question.campos.forEach(field => {
                if (field.tipo === 'checkbox') {
                  answer[field.texto] = [];
                } else {
                  answer[field.texto] = "";
                }
              });
            }
            break;
          case "GRUPO_REPETIBLE":
            answer = [];
            let emptyGroup = {};
            if (question.campos) {
              question.campos.forEach(field => {
                if(field.otro) {
                  if(!field.opciones.includes("99.1. Otro (especifique)")) {
                    // console.log(field.opciones)
                    field.opciones.push("99.1. Otro (especifique)")
                  }
                }
                if (field.tipo === 'checkbox') {
                  emptyGroup[field.texto] = [];
                } else {
                  emptyGroup[field.texto] = "";
                }
              });
            }
            answer.push(emptyGroup);
            break;
          case "OPCION_SEGUIMIENTO":
            answer = [];
            if (question.otro) {
              answer["otro"] = "";
              if(!question.conceptos.includes("99.1. Otro (especifique)")) {
                // console.log(question.conceptos)
                question.conceptos.push("99.1. Otro (especifique)")
              }
            }
            if (question.conceptos) {
              question.conceptos.forEach(concepto => {
                answer.push({
                  concepto: concepto,
                  selected_answer: "",
                  sub_respuesta: question.sub_tipo === 'checkbox' ? [] : ""
                });
              });
            }
            break;
          case "MATRIZ":
            answer = {};
            if (question.filas) {
              question.filas.forEach(fila => {
                answer[fila] = null;
              });
            }
            break;
          case "SECCION":
            answer = null;
            break;
          default:
            break;
        }

        let answerQuestion = {
          id_pregunta: question.id_pregunta,
          texto: question.texto,
          tipo: question.tipo,
          respuesta: answer,
          respuesta_otro_fila: "",
          respuesta_otro_valor: null,
          obligatoria: question.obligatoria,
          error: false
        };

        if (
          answerQuestion.tipo === "ABIERTA" ||
          answerQuestion.tipo === "CAMPOS" ||
          answerQuestion.tipo === "MINI_FORMULARIO" ||
          answerQuestion.tipo === "GRUPO_REPETIBLE"
        ) {
          answerQuestion.sensible = false;
        }

        this.answers.push(answerQuestion);
      });
    },
    isQuestionVisible(index) {
      if (index === 0) return true;
      let targetJumpIndex = -1;

      for (let i = 0; i < index; i++) {
        let q = this.questions[i];
        let a = this.answers[i];
        if (q.tipo === "SELECCION" && q.saltos && a && a.respuesta) {
          let selectedVal = a.respuesta.selected_answer;
          let saltoTarget = null;
          
          if (selectedVal !== "") {
            if (selectedVal === "Otro") {
              saltoTarget = q.saltos['otro'];
            } else {
              let optIndex = q.opciones.indexOf(selectedVal);
              if (optIndex !== -1) {
                saltoTarget = q.saltos[optIndex];
              }
            }

            if (saltoTarget) {
              let tIndex = this.questions.findIndex(x => x.numero_pregunta == saltoTarget);
              if (tIndex > i && tIndex > targetJumpIndex) {
                targetJumpIndex = tIndex;
              }
            }
          }
        }
      }

      return index >= targetJumpIndex;
    },
    addRepeatableGroup(index) {
      let emptyGroup = {};
      if (this.questions[index].campos) {
        this.questions[index].campos.forEach(field => {
          if (field.tipo === 'checkbox') {
            emptyGroup[field.texto] = [];
          } else {
            emptyGroup[field.texto] = "";
          }
        });
      }
      this.answers[index].respuesta.push(emptyGroup);
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
